import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";

import {
  getSelectedDate,
  setVisibleCalendar,
  setVisibleRangeCalendar,
  getVisibleCalendar,
  setSelectedDate,
  setDisablePreviousDates,
  getVisibleRangeCalendar,
} from "slices";
import { ButtonComp } from "components";

const DatePickerOptionTile = ({ compKey, disabled, componentOptions, onDateClick, classes, optionsType }) => {
  const dispatch = useDispatch();
  const selectedDate = useSelector(getSelectedDate);
  const visibleCalendar = useSelector(getVisibleCalendar);
  const visibleRangeCalendar = useSelector(getVisibleRangeCalendar);

  const isRangeCalendar = compKey === "custom_date";

  const onCalendarOpen = () => {
    if (isRangeCalendar) {
      dispatch(setVisibleRangeCalendar(true));
    } else {
      dispatch(setVisibleCalendar(true));
    }

    dispatch(setSelectedDate(""));
    dispatch(setDisablePreviousDates(componentOptions.disablePreviousDates || false));
  };

  useEffect(() => {
    if ((visibleCalendar || visibleRangeCalendar) && !isEmpty(selectedDate)) {
      const rangeFormat = `${selectedDate.split(",")[0]} - ${selectedDate.split(",")[1]}`;

      const newMessage = [{ message: isRangeCalendar ? rangeFormat : selectedDate, speaker: "user", optionsType }];
      const callbackOptions = { ...componentOptions.callbackOptions, data: { ...componentOptions.callbackOptions.data, data: selectedDate } };

      if (isRangeCalendar) {
        dispatch(setVisibleRangeCalendar(false));
      } else {
        dispatch(setVisibleCalendar(false));
      }

      onDateClick(newMessage, callbackOptions);
      dispatch(setSelectedDate(""));
    }
  }, [selectedDate, visibleCalendar]);

  return (
    <ButtonComp
      className={`${classes}`}
      testId={isRangeCalendar ? "customRange" : "selectCalendar"}
      onClick={onCalendarOpen}
      label={isRangeCalendar ? t("customRange") : t("selectCalendar")}
      disabled={disabled}
    />
  );
};

export default DatePickerOptionTile;
